import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import * as App from '../../app'
import * as Menu from '../../components/menu'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Filters from './filters'

const onEnter = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.CONTENT_SOURCE_URL + '/'))
  .map((action: Router.OnEnterAction) =>
    Actions.fetchSingleSource(
      store.getState().app.selectedCommunity,
      action.params.sourceIdentifier))

const onReset = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(Constants.RESET_SOURCE)
  .map(() =>
    Actions.fetchSingleSource(
      store.getState().app.selectedCommunity,
      store.getState().source.data.config.id))

export const epic = ReduxObservable.combineEpics(
  onEnter,
  onReset,
  Filters.epic,
)



// WEBPACK FOOTER //
// ./src/pages/source-config/epic.ts